import { render, staticRenderFns } from "./upcoming-deliveries.vue?vue&type=template&id=9dc605e0&scoped=true"
import script from "./upcoming-deliveries.vue?vue&type=script&lang=js"
export * from "./upcoming-deliveries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dc605e0",
  null
  
)

export default component.exports